(function(){
  var UNIT_TO_FT = { ft: 1, 'in': 1/12, cm: 0.0328084, m: 3.28084 };
  function fmt(n){ return '$' + (Number(n)||0).toFixed(2); }
  function parseJSONSafe(s, fallback){ try { return JSON.parse(s); } catch(e){ return fallback; } }
  document.addEventListener('DOMContentLoaded', function(){
    var form = document.querySelector('.bds-fabric-form');
    if (!form) return;
    var priceEl = document.getElementById('bds-price-value');
    var totalEl = document.getElementById('bds-total-value');
    var qtyDollars = document.getElementById('bds-qty-dollars');
    var wEl = document.getElementById('bds-w');
    var hEl = document.getElementById('bds-h');
    var unitEl = document.getElementById('bds-unit');
    var qtyEl = document.getElementById('bds-qty');
    var fabricSel = document.getElementById('bds-fabric-select');
    var addonSelects = form.querySelectorAll('.bds-addon');
    var variantIdInput = form.querySelector('input[name=id]');
    var currentData = {
      rate: parseFloat(form.dataset.rate) || 2,
      flatFees: parseJSONSafe(form.dataset.flatFees, []),
      ranges: parseJSONSafe(form.dataset.shippingRanges, [])
    };
    function calc(){
      var w = parseFloat(wEl && wEl.value) || 0;
      var h = parseFloat(hEl && hEl.value) || 0;
      var qty = parseInt(qtyEl && qtyEl.value) || 1;
      var unit = (unitEl && unitEl.value) || 'ft';
      var factor = UNIT_TO_FT[unit] || 1;
      var sqft = w * factor * h * factor * qty;
      var flat = 0;
      // Tier lookup: pick first tier whose upper bound is >= sqft.
      // Ranges are contiguous like [1,22],[23,60],[61,88]... this handles decimal gaps (e.g. 22.5 sqft).
      if (currentData.ranges && currentData.ranges.length){
        var found = false;
        for (var i = 0; i < currentData.ranges.length; i++){
          var r = currentData.ranges[i];
          if (sqft <= r[1]){ flat = currentData.flatFees[i] || 0; found = true; break; }
        }
        if (!found && currentData.flatFees.length){ flat = currentData.flatFees[currentData.flatFees.length - 1]; }
      }
      var addonTotal = 0;
      (addonSelects || []).forEach(function(sel){ var parts = (sel.value || '').split('|'); if (parts.length === 2){ addonTotal += parseFloat(parts[1]) || 0; } });
      var total = sqft * currentData.rate + flat + addonTotal;
      if (qtyDollars) qtyDollars.value = Math.max(1, Math.ceil(total));
      var shown = fmt(total);
      if (priceEl) priceEl.textContent = shown;
      if (totalEl) totalEl.textContent = shown;
    }
    if (fabricSel){
      fabricSel.addEventListener('change', function(){
        var opt = fabricSel.options[fabricSel.selectedIndex];
        currentData.rate = parseFloat(opt.getAttribute('data-rate')) || currentData.rate;
        currentData.flatFees = parseJSONSafe(opt.getAttribute('data-flat-fees'), []);
        currentData.ranges = parseJSONSafe(opt.getAttribute('data-shipping-ranges'), []);
        if (variantIdInput) variantIdInput.value = opt.value;
        calc();
      });
    }
    var inputs = [wEl, hEl, unitEl, qtyEl].concat(Array.prototype.slice.call(addonSelects));
    inputs.forEach(function(el){ if (!el) return; el.addEventListener('input', calc); el.addEventListener('change', calc); });
    form.addEventListener('submit', function(){ calc(); });
    calc();
  });
})();
